import React from 'react';
import { get } from 'lodash';
import { Input } from '@oscar/theme';

const ReadOnlyInput: React.FC<{
  value?: string | number;
  data: Record<string, any>[];
  textField: string;
}> = ({ value, data, textField }) => {
  const selectedItem = data.find((option: any) => option?.id === value);
  return <Input placeholder="" disabled value={get(selectedItem, textField)} />;
};

export default ReadOnlyInput;
